import React from 'react'
import "./services.css";

import { Link } from 'react-router-dom';

const ServicesComponent = () => {
  return (
    <div>
        <div className="services">
      <h1 className="service-heading">What I provide</h1>
        <div className="service-container">
          <div className="card">
            <h3>Web Design</h3>
            <span className="bar"></span>
            <p>Well, I've been designing websites for over 2 years now, and I have over 30 sites design in my portfolio! I will provide amazing PSD/Figma to web template design for your Blog, Wodpress, eCommerce, Shopify, Wix, or any custom website.</p>
            <Link to="/contact" className='btn'>Message Now</Link>
          </div>
          <div className="card">
            <h3>Web Development</h3>
            <span className="bar"></span>
            <p>I have been working as a front-end web developer, having strong command on PSD to HTML, HTML5, CSS3, Bootstrap, Javascript, React.Js. I do clean and error-free code with a proper commendation for each step's clarification</p>
            <Link to="/contact" className='btn'>Message Now</Link>
          </div>
          <div className="card">
            <h3>Content Writing</h3>
            <span className="bar"></span>
            <p>I'm a long-time freelance writer, internet marketer, and website owner and know how to use SEO to make traffic-grabbing content. Every article will be researched, written with care, and delivered on time. I never use automatic programs or outsource my work.</p>
            <Link to="/contact" className='btn'>Message Now</Link>
          </div>
          <div className="card">
            <h3>Digital Marketing</h3>
            <span className="bar"></span>
            <p>I'm an Expert Digital Marketer Plus hands-on Search Engine Optimization (SEO), Social Media Management (SMM), and content writing services. I have worked really hard and my hard work has appeared in the field of Detral(Pvt)Ltd. I have 50+ Professional team members. Including Social media Manager, SEO Expert, and Content Writer</p>
            <Link to="/contact" className='btn'>Message Now</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServicesComponent;